import React, { useState } from "react";
import Icon from "../utils/icons";
import { useInstallApp } from "../utils/installApp";

// "Install app" in the phone menu and the footer: the browser's install prompt, or on an iPhone how to add the store
// to the home screen. Nothing shows when the store is already installed or the browser can't install it.
export default function InstallApp({ className = "", storeName }) {
    const { available, iosHelp, install } = useInstallApp();
    const [help, setHelp] = useState(false);
    if (!available) return null;
    return (
        <>
            <button type="button" className={`installAppBtn ${className}`} onClick={() => (iosHelp ? setHelp(true) : install())}>
                <Icon.Phone /> Install app
            </button>
            {help && (
                <div className="modal" role="dialog" aria-modal="true" aria-label="Install this store as an app" onMouseDown={(e) => e.target === e.currentTarget && setHelp(false)}>
                    <div className="installHelp">
                        <h3>Add {storeName} to your home screen</h3>
                        <ol>
                            <li>Tap the <b>Share</b> button <Icon.BoxArrowUp /> at the bottom of Safari.</li>
                            <li>Choose <b>Add to Home Screen</b>.</li>
                            <li>Tap <b>Add</b>. The store opens from your home screen like an app.</li>
                        </ol>
                        <button type="button" className="green" onClick={() => setHelp(false)}>Got it</button>
                    </div>
                </div>
            )}
        </>
    );
}
